import { observable, computed } from 'mobx'
import _ from 'lodash'

/**
 * Store attempts to be some sort of base class for our various mobx stores.
 *
 * It is based around the idea of a `records` propeprties that store the database and then has lots of convenience methods for things like:
 * - backend API CRUD included
 * - Enumerable mixin
 *
 */

const emptyIterator = function*(){}

const delegate = (proto, name) => ({
  type: 'method',
  enumerable: false,
  configurable: false,
  writable: false,
  initializer() { return function (...args) {
    return (this.records || [])[name](...args)
  }}
})

export default class Store {
  @observable records

  @computed get loaded() {
    return this.records !== undefined
  }

  @delegate map
  @delegate forEach
  @delegate filter
  @delegate reduce
  @delegate find
  @delegate findIndex

  constructor(connection) {
    this.connection = connection
    this[Symbol.iterator] = () => {
      return this.records ? this.records[Symbol.iterator]() : emptyIterator()
    }

    this.load = this.load.bind(this)
    this.create = this.create.bind(this)
    this.update = this.update.bind(this)
    this.delete = this.delete.bind(this)
  }

  findById = id => this.find(item => item.id === Number(id))
  findIndexById = id => this.findIndex(item => item.id === Number(id))

  load(id) {
    return this.connection.load(id)
      .then(resp => resp.data)
      .then(data => {
        if (id) {
          if (this.findById(id)) {
            this.records[this.findIndexById(data.id)] = data
          } else {
            this.records = [ ...(this.records || []), data ]
          }
        } else {
          this.records = data
        }
      })
  }

  create(data) {
    return this.connection.create(this.hierarchichalizeData(data))
      .then(resp => resp.data)
      .then(data => {
        this.records = [ ...(this.records || []), data ]
        return data
      })
  }

  update(data) {
    return this.connection.update(this.hierarchichalizeData(data))
      .then(() => {
        this.records[this.findIndexById(data.id)] = data
        return data
      })
  }

  delete(id) {
    return this.connection.delete(id)
      .then(() => this.records.remove(this.findById(id)))
  }

  hierarchichalizeData(data) {
    var hData = {}
    _.map(data, (v, k) => {
      var m = k.split('.')
      switch (m.length) {
        case 1:
          hData[k] = v
          break
        case 2:
          if (typeof(hData[m[0]]) === 'undefined') {
            hData[m[0]] = {}
          }
          hData[m[0]][m[1]] = v
          break
        case 3:
          if (typeof(hData[m[0]]) === 'undefined') hData[m[0]] = {}
          if (typeof(hData[m[0]][m[1]]) === 'undefined') hData[m[0]][m[1]] = {}

          hData[m[0]][m[1]][m[2]] = v
          break
        case 0:
          throw new Error("Empty key?" + k)
        default:
          throw new Error("Only one or two dots allowed at " + k)
      }
    })
    return hData
  }

}



// WEBPACK FOOTER //
// client/stores/store.js